import { useQuery } from '@tanstack/react-query';
import { employmentTypeApi } from '../employmentTypeApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetEmploymentType = () => {
  return useQuery({
    queryKey: [QueryKey.GET_EMPLOYMENT_TYPES],
    queryFn: () =>
      employmentTypeApi.getEmploymentTypes({
        paginate: PaginateType.NONE,
        filter: {},
      }),
  });
};
